var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddFolderIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 45.5H52.5H31.5ZM42 35V56V35ZM10.5 59.5V24.5C10.5 22.6435 11.2375 20.863 12.5503 19.5503C13.863 18.2375 15.6435 17.5 17.5 17.5H38.5L45.5 24.5H66.5C68.3565 24.5 70.137 25.2375 71.4497 26.5503C72.7625 27.863 73.5 29.6435 73.5 31.5V59.5C73.5 61.3565 72.7625 63.137 71.4497 64.4497C70.137 65.7625 68.3565 66.5 66.5 66.5H17.5C15.6435 66.5 13.863 65.7625 12.5503 64.4497C11.2375 63.137 10.5 61.3565 10.5 59.5Z",
    stroke: "#6B7280",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddFolderIcon);
export default __webpack_public_path__ + "static/media/addFolderIcon.f0294a88c8b2ddd8bc31a4102fb7d446.svg";
export { ForwardRef as ReactComponent };